import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { LayoutDashboard, Package, ShoppingCart, LogOut, Menu, X, Settings, Folder, FileText, Grid, Users, ArrowUpDown, Tag, BarChart3, ShieldCheck, MessageSquare } from 'lucide-react';

const AdminLayout = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleLogout = async () => {
    try {
      const API_URL = process.env.REACT_APP_BACKEND_URL;
      await fetch(`${API_URL}/api/admin/logout`, { method: 'POST' });
    } catch (_) { /* ignore network errors on logout */ }
    localStorage.removeItem('adminToken');
    navigate('/admin/login');
  };

  const menuItems = [
    { path: '/admin/dashboard', icon: LayoutDashboard, label: 'Dashboard' },
    { path: '/admin/slider', icon: Grid, label: 'Ana Sayfa Slider' },
    { path: '/admin/products', icon: Package, label: 'Ürünler' },
    { path: '/admin/categories', icon: Folder, label: 'Kategoriler' },
    { path: '/admin/sorting', icon: ArrowUpDown, label: 'Sıralama' },
    { path: '/admin/collections', icon: Grid, label: 'Koleksiyonlar' },
    { path: '/admin/pages', icon: FileText, label: 'Sayfalar' },
    { path: '/admin/orders', icon: ShoppingCart, label: 'Siparişler' },
    { path: '/admin/reviews', icon: MessageSquare, label: 'Yorumlar' },
    { path: '/admin/reports', icon: BarChart3, label: 'Raporlar' },
    { path: '/admin/discounts', icon: Tag, label: 'İndirim Kodları' },
    { path: '/admin/users', icon: Users, label: 'Üyeler' },
    { path: '/admin/profile', icon: ShieldCheck, label: 'Profil & Güvenlik' },
    { path: '/admin/settings', icon: Settings, label: 'Site Ayarları' },
  ];

  return (
    <div className="min-h-screen bg-gray-100">
      {/* Header */}
      <header className="bg-white shadow-sm">
        <div className="flex items-center justify-between px-4 py-4">
          <div className="flex items-center gap-4">
            <button
              onClick={() => setSidebarOpen(!sidebarOpen)}
              className="md:hidden text-gray-600 hover:text-red-600"
            >
              {sidebarOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
            <div className="bg-gradient-to-r from-red-600 to-red-700 text-white px-4 py-2 font-bold text-lg transform -skew-x-12">
              <span className="inline-block transform skew-x-12">⚡ Cep Premium Admin</span>
            </div>
          </div>
          <button
            onClick={handleLogout}
            className="flex items-center gap-2 px-4 py-2 text-gray-600 hover:text-red-600 transition-colors"
          >
            <LogOut size={20} />
            <span className="hidden sm:inline">Çıkış Yap</span>
          </button>
        </div>
      </header>

      <div className="flex">
        {/* Sidebar */}
        <aside className={`
          fixed md:static inset-y-0 left-0 z-50 w-64 bg-white shadow-lg transform transition-transform duration-300 ease-in-out
          ${sidebarOpen ? 'translate-x-0' : '-translate-x-full md:translate-x-0'}
        `}>
          <nav className="p-4 mt-16 md:mt-0">
            <ul className="space-y-2">
              {menuItems.map((item) => {
                const Icon = item.icon;
                const isActive = location.pathname === item.path;
                return (
                  <li key={item.path}>
                    <Link
                      to={item.path}
                      onClick={() => setSidebarOpen(false)}
                      className={`flex items-center gap-3 px-4 py-3 rounded-lg transition-colors ${
                        isActive
                          ? 'bg-red-600 text-white'
                          : 'text-gray-700 hover:bg-gray-100'
                      }`}
                    >
                      <Icon size={20} />
                      <span className="font-medium">{item.label}</span>
                    </Link>
                  </li>
                );
              })}
            </ul>
          </nav>
        </aside>

        {/* Main Content */}
        <main className="flex-1 p-6">
          {children}
        </main>
      </div>

      {/* Mobile Overlay */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40 md:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}
    </div>
  );
};

export default AdminLayout;
